// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CookieConsentController from "./cookie_consent_controller"
application.register("cookie-consent", CookieConsentController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

// MobileMenuController removed — replaced by vanilla JS in mobile_menu.js
